// Text and menu of the gym pack, kept free of page imports so it can be tested on its own (like packs/menus.js).
export const gymMessages = {
  ar: {
    "common.alert": "تنبيه",
    "common.done": "تم بنجاح",
    "common.failed": "حصلت مشكلة، حاول تاني",
    "common.save": "حفظ",
    "common.delete": "حذف",

    "nav.plans": "خطط العضوية",
    "nav.members": "الأعضاء",
    "nav.trainers": "المدربين",
    "nav.courses": "البرامج",
    "nav.content": "محتوى الصفحة الرئيسية",

    "gym.plans": "خطط العضوية",
    "gym.plans.new": "خطة جديدة",
    "gym.plans.edit": "تعديل الخطة",
    "gym.plans.name": "اسم الخطة",
    "gym.plans.nameRequired": "اكتب اسم الخطة",
    "gym.plans.description": "وصف مختصر",
    "gym.plans.price": "السعر",
    "gym.plans.currency": "العملة",
    "gym.plans.interval": "المدة",
    "gym.plans.monthly": "شهري",
    "gym.plans.quarterly": "كل 3 شهور",
    "gym.plans.yearly": "سنوي",
    "gym.plans.trialDays": "أيام التجربة المجانية",
    "gym.plans.enabled": "الخطة متاحة للاشتراك",
    "gym.plans.members": "الأعضاء الشغّالين",
    "gym.plans.status": "الحالة",
    "gym.plans.on": "متاحة",
    "gym.plans.off": "موقوفة",
    "gym.plans.saved": "اتحفظت الخطة",
    "gym.plans.deleteNote": "لو عليها أعضاء أو برامج السيرفر هيرفض المسح — أوقفها بدل ما تمسحها.",
    "gym.plans.emptyTitle": "لسه ما عملتش خطط",
    "gym.plans.emptyText": "اعمل أول خطة (شهري مثلًا) علشان الأعضاء يقدروا يشتركوا.",

    "gym.members": "الأعضاء",
    "gym.members.add": "تفعيل عضو",
    "gym.members.activate": "تفعيل",
    "gym.members.activated": "اتفعّلت العضوية",
    "gym.members.member": "العضو",
    "gym.members.pick": "اختار العضو",
    "gym.members.plan": "الخطة",
    "gym.members.months": "عدد الشهور",
    "gym.members.monthsHint": "سيبها فاضية = مدة الخطة",
    "gym.members.mobile": "الموبايل",
    "gym.members.status": "الحالة",
    "gym.members.endsAt": "تنتهي في",
    "gym.members.extend": "تمديد",
    "gym.members.end": "إنهاء العضوية",
    "gym.members.endTitle": "تنهي العضوية؟",
    "gym.members.endNote": "العضو هيفقد الوصول للبرامج فورًا.",
    "gym.members.search": "بحث في الأعضاء",
    "gym.members.emptyTitle": "لسه مفيش أعضاء",
    "gym.members.emptyText": "طلبات الاشتراك والتجارب المجانية بتظهر هنا.",
    "gym.status.PENDING": "طلب جديد",
    "gym.status.TRIAL": "تجربة",
    "gym.status.ACTIVE": "شغّال",
    "gym.status.EXPIRED": "منتهي",
    "gym.status.CANCELED": "ملغي",

    "gym.trainers": "المدربين",
    "gym.trainers.mode": "نوع الحساب",
    "gym.trainers.solo": "مدرب لوحدي",
    "gym.trainers.team": "فريق مدربين",
    "gym.trainers.soloTitle": "حسابك مدرب فردي",
    "gym.trainers.soloNote": "برامجك بتتنسب لك تلقائيًا. لو عندك فريق حوّل لـ «فريق مدربين» وضيف المدربين.",
    "gym.trainers.new": "مدرب جديد",
    "gym.trainers.edit": "تعديل المدرب",
    "gym.trainers.name": "الاسم",
    "gym.trainers.nameRequired": "اكتب اسم المدرب",
    "gym.trainers.specialty": "التخصص",
    "gym.trainers.bio": "نبذة",
    "gym.trainers.image": "رابط الصورة",
    "gym.trainers.enabled": "ظاهر في الموقع",
    "gym.trainers.status": "الحالة",
    "gym.trainers.you": "إنت",
    "gym.trainers.saved": "اتحفظ المدرب",
    "gym.trainers.deleteNote": "لو فيه برامج مربوطة بالمدرب السيرفر هيرفض المسح — أوقفه بدلها.",
    "gym.setup.title": "تجهيز حسابك",
    "gym.setup.stepOf": "الخطوة {n} من {total}",
    "gym.setup.step.link": "رابطك",
    "gym.setup.step.mode": "نوع الحساب",
    "gym.setup.step.plan": "أول خطة",
    "gym.setup.step.program": "أول برنامج",
    "gym.setup.linkTitle": "اختار رابط موقعك",
    "gym.setup.linkText": "ده الرابط اللي أعضاؤك هيدخلوا بيه على موقعك. اختار اسم مميز وسهل، ومش هيتكرر مع حد.",
    "gym.setup.linkHint": "اكتب الاسم بالإنجليزي، 3 أحرف على الأقل.",
    "gym.setup.linkShort": "الرابط 3 أحرف على الأقل",
    "gym.setup.checking": "جاري التأكد من الإتاحة...",
    "gym.setup.available": "متاح",
    "gym.setup.taken": "محجوز، جرّب اسم تاني",
    "gym.setup.next": "التالي",
    "gym.setup.back": "السابق",
    "gym.setup.saving": "جاري الحفظ...",
    "gym.setup.skip": "كمّل من غير خطة تانية",
    "gym.setup.later": "بعدين",
    "gym.setup.modeTitle": "إنت مدرب لوحدك ولا معاك فريق؟",
    "gym.setup.modeText": "تقدر تغيّره في أي وقت من صفحة المدربين.",
    "gym.setup.soloText": "البرامج بتتنسب لك، والموقع بيعرض نبذة عنك.",
    "gym.setup.teamText": "بتضيف مدربين، والموقع بيعرض الفريق وتقدر تقسم البرامج عليهم.",
    "gym.setup.planTitle": "ضيف أول خطة عضوية",
    "gym.setup.planText": "الخطة هي اللي العضو بيشترك فيها: شهري مثلًا بسعر معين، وتقدر تدّي تجربة مجانية. تقدر تعدّلها وتضيف غيرها بعدين.",
    "gym.setup.planNameHint": "مثلًا: الاشتراك الشهري",
    "gym.setup.priceRequired": "اكتب السعر (0 لو مجانية)",
    "gym.setup.addPlan": "إضافة الخطة",
    "gym.setup.planDone": "اتضافت {n} خطة",
    "gym.setup.programTitle": "ارفع أول برنامج",
    "gym.setup.programText": "البرنامج مجموعة فيديوهات تمرين. ارفع أول فيديو علشان موقعك ما يبقاش فاضي.",
    "gym.setup.readyText": "موقعك جاهز دلوقتي. تقدر تكمّل الباقي من لوحة التحكم في أي وقت.",
    "gym.setup.addProgram": "ارفع أول برنامج",
    "content": "محتوى الصفحة الرئيسية",
    "content.noteTitle": "النصوص اللي بتظهر في موقعك",
    "content.note": "ثيم موقعك بيرتّب بلوكات في الصفحة الرئيسية (أرقام، مميزات، آراء، أسئلة...). هنا بتكتب النصوص اللي جوّاها. أي حاجة تسيبها فاضية البلوك بتاعها بيختفي. الصور والعنوان الرئيسي من «هوية الموقع»، والخطط والمدربين من صفحاتهم.",
    "content.cta": "زرار التجربة المجانية والشريط الختامي",
    "content.ctaLabel": "كلام الزرار (الافتراضي: ابدأ تجربتك المجانية)",
    "content.ctaTitle": "عنوان الشريط الختامي",
    "content.ctaText": "نص الشريط الختامي",
    "content.stats": "أرقام تثق فيها",
    "content.statsHint": "لحد 4 أرقام، مثلًا «1,200+» و«أعضاء».",
    "content.statValue": "الرقم",
    "content.statLabel": "الوصف",
    "content.features": "المميزات",
    "content.icon": "أيقونة (إيموجي)",
    "content.title": "العنوان",
    "content.text": "النص",
    "content.testimonials": "آراء الأعضاء",
    "content.name": "الاسم",
    "content.role": "الوصف (اختياري)",
    "content.quote": "الرأي",
    "content.faq": "أسئلة شائعة",
    "content.question": "السؤال",
    "content.answer": "الإجابة",
    "content.apps": "تطبيق الموبايل",
    "content.ios": "رابط App Store",
    "content.android": "رابط Google Play",
    "content.add": "إضافة",
    "content.saved": "اتحفظ المحتوى",
    "nav.library": "المكتبة",
    "nav.calendar": "تقويم التمارين",

    "gym.library": "المكتبة",
    "gym.library.tags": "الوسوم",
    "gym.library.tagsHint": "الوسوم هي اللي الأعضاء بيفلتروا بيها المكتبة: نوع التمرين، المعدات، التركيز، وجزء الجسم.",
    "gym.library.type.STYLE": "النوع",
    "gym.library.type.EQUIPMENT": "المعدات",
    "gym.library.type.FOCUS": "التركيز",
    "gym.library.type.BODY_AREA": "جزء الجسم",
    "gym.library.tagName": "اسم الوسم",
    "gym.library.addTag": "إضافة وسم",
    "gym.library.deleteTag": "تمسح الوسم «{name}» من كل الفيديوهات؟",
    "gym.library.remove": "مسح",
    "gym.library.videos": "فيديوهات",
    "gym.library.recipes": "وصفات",
    "gym.library.search": "بحث بالعنوان",
    "gym.library.byTag": "فلتر بوسم",
    "gym.library.title": "العنوان",
    "gym.library.program": "البرنامج",
    "gym.library.duration": "المدة",
    "gym.library.editTags": "تعديل الوسوم",
    "gym.library.tagsOf": "وسوم: {title}",
    "gym.library.noTags": "ضيف وسوم الأول من فوق.",
    "gym.library.saved": "اتحفظت الوسوم",
    "gym.library.emptyTitle": "المكتبة فاضية",
    "gym.library.emptyText": "الفيديوهات والوصفات بتظهر هنا بعد ما ترفعها جوّه البرامج.",

    "gym.calendar": "تقويم التمارين",
    "gym.calendar.new": "تقويم جديد",
    "gym.calendar.edit": "تعديل التقويم",
    "gym.calendar.name": "اسم التقويم",
    "gym.calendar.nameRequired": "اكتب اسم التقويم",
    "gym.calendar.forPlan": "لأعضاء خطة",
    "gym.calendar.allMembers": "كل الأعضاء",
    "gym.calendar.enabled": "ظاهر للأعضاء",
    "gym.calendar.saved": "اتحفظ التقويم",
    "gym.calendar.deleteNote": "مسح التقويم بيمسح كل أيامه.",
    "gym.calendar.emptyTitle": "لسه مفيش تقويم",
    "gym.calendar.emptyText": "اعمل تقويم شهري وحط فيه تمرين كل يوم، والعضو يشوف تمرين النهارده.",
    "gym.calendar.addTo": "إضافة لليوم {day}",
    "gym.calendar.add": "إضافة",
    "gym.calendar.remove": "شيل",
    "gym.calendar.kind.item": "فيديو / وصفة",
    "gym.calendar.kind.program": "برنامج",
    "gym.calendar.kind.note": "ملاحظة / راحة",
    "gym.calendar.item": "الفيديو أو الوصفة",
    "gym.calendar.program": "البرنامج",
    "gym.calendar.pick": "اختار",
    "gym.calendar.noteTitle": "العنوان",
    "gym.calendar.restDay": "يوم راحة",
    "gym.calendar.note": "ملاحظة",
    "gym.calendar.pickSomething": "اختار حاجة الأول",
    "gym.calendar.dragHint": "اسحب أي عنصر ليوم تاني علشان تنقله",
    "gym.trainers.emptyTitle": "لسه ما ضفتش مدربين",
    "gym.trainers.emptyText": "ضيف أول مدرب في الفريق.",
  },
  en: {
    "common.alert": "Notice",
    "common.done": "Done",
    "common.failed": "Something went wrong, try again",
    "common.save": "Save",
    "common.delete": "Delete",
    "nav.plans": "Membership plans",
    "nav.members": "Members",
    "nav.trainers": "Trainers",
    "nav.courses": "Programs",
    "nav.content": "Home page content",
    "nav.library": "Library",
    "nav.calendar": "Workout calendar",
    "gym.plans": "Membership plans",
    "gym.plans.new": "New plan",
    "gym.plans.edit": "Edit plan",
    "gym.plans.name": "Plan name",
    "gym.plans.nameRequired": "Enter the plan name",
    "gym.plans.description": "Short description",
    "gym.plans.price": "Price",
    "gym.plans.currency": "Currency",
    "gym.plans.interval": "Duration",
    "gym.plans.monthly": "Monthly",
    "gym.plans.quarterly": "Every 3 months",
    "gym.plans.yearly": "Yearly",
    "gym.plans.trialDays": "Free trial days",
    "gym.plans.enabled": "Plan is open for sign-up",
    "gym.plans.members": "Active members",
    "gym.plans.status": "Status",
    "gym.plans.on": "Available",
    "gym.plans.off": "Paused",
    "gym.plans.saved": "Plan saved",
    "gym.plans.deleteNote": "If it has members or programs the server will refuse to delete it. Pause it instead.",
    "gym.plans.emptyTitle": "No plans yet",
    "gym.plans.emptyText": "Create your first plan (monthly, for example) so members can subscribe.",
    "gym.members": "Members",
    "gym.members.add": "Activate a member",
    "gym.members.activate": "Activate",
    "gym.members.activated": "Membership activated",
    "gym.members.member": "Member",
    "gym.members.pick": "Choose the member",
    "gym.members.plan": "Plan",
    "gym.members.months": "Number of months",
    "gym.members.monthsHint": "Leave empty to use the plan duration",
    "gym.members.mobile": "Mobile",
    "gym.members.status": "Status",
    "gym.members.endsAt": "Ends on",
    "gym.members.extend": "Extend",
    "gym.members.end": "End membership",
    "gym.members.endTitle": "End this membership?",
    "gym.members.endNote": "The member loses access to the programs immediately.",
    "gym.members.search": "Search members",
    "gym.members.emptyTitle": "No members yet",
    "gym.members.emptyText": "Sign-up requests and free trials show up here.",
    "gym.status.PENDING": "New request",
    "gym.status.TRIAL": "Trial",
    "gym.status.ACTIVE": "Active",
    "gym.status.EXPIRED": "Expired",
    "gym.status.CANCELED": "Canceled",
    "gym.trainers": "Trainers",
    "gym.trainers.mode": "Account type",
    "gym.trainers.solo": "Solo coach",
    "gym.trainers.team": "Team of trainers",
    "gym.trainers.soloTitle": "Your account is a solo coach",
    "gym.trainers.soloNote": "Your programs are credited to you automatically. If you have a team, switch to Team of trainers and add them.",
    "gym.trainers.new": "New trainer",
    "gym.trainers.edit": "Edit trainer",
    "gym.trainers.name": "Name",
    "gym.trainers.nameRequired": "Enter the trainer name",
    "gym.trainers.specialty": "Specialty",
    "gym.trainers.bio": "Bio",
    "gym.trainers.image": "Image link",
    "gym.trainers.enabled": "Shown on the site",
    "gym.trainers.status": "Status",
    "gym.trainers.you": "You",
    "gym.trainers.saved": "Trainer saved",
    "gym.trainers.deleteNote": "If programs are linked to the trainer the server will refuse to delete. Pause them instead.",
    "gym.trainers.emptyTitle": "No trainers yet",
    "gym.trainers.emptyText": "Add the first trainer of your team.",
    "gym.setup.title": "Set up your account",
    "gym.setup.stepOf": "Step {n} of {total}",
    "gym.setup.step.link": "Your link",
    "gym.setup.step.mode": "Account type",
    "gym.setup.step.plan": "First plan",
    "gym.setup.step.program": "First program",
    "gym.setup.linkTitle": "Pick your site link",
    "gym.setup.linkText": "This is the link your members use to reach your site. Pick a short, memorable name nobody else has.",
    "gym.setup.linkHint": "Use English letters, at least 3.",
    "gym.setup.linkShort": "The link needs at least 3 characters",
    "gym.setup.checking": "Checking availability...",
    "gym.setup.available": "Available",
    "gym.setup.taken": "Taken, try another name",
    "gym.setup.next": "Next",
    "gym.setup.back": "Back",
    "gym.setup.saving": "Saving...",
    "gym.setup.skip": "Continue without another plan",
    "gym.setup.later": "Later",
    "gym.setup.modeTitle": "Do you coach alone or with a team?",
    "gym.setup.modeText": "You can change it any time from the Trainers page.",
    "gym.setup.soloText": "Programs are credited to you and the site shows your bio.",
    "gym.setup.teamText": "You add trainers, the site shows the team and you can split programs between them.",
    "gym.setup.planTitle": "Add your first membership plan",
    "gym.setup.planText": "A plan is what a member subscribes to: monthly at a set price, for example, with an optional free trial. You can edit it and add more later.",
    "gym.setup.planNameHint": "For example: Monthly membership",
    "gym.setup.priceRequired": "Enter the price (0 if free)",
    "gym.setup.addPlan": "Add the plan",
    "gym.setup.planDone": "{n} plan(s) added",
    "gym.setup.programTitle": "Upload your first program",
    "gym.setup.programText": "A program is a set of workout videos. Upload the first video so your site is not empty.",
    "gym.setup.readyText": "Your site is ready now. You can finish the rest from the dashboard any time.",
    "gym.setup.addProgram": "Upload your first program",
    "content": "Home page content",
    "content.noteTitle": "The texts shown on your site",
    "content.note": "Your site theme lays out blocks on the home page (numbers, features, reviews, questions...). Write the texts inside them here; a block you leave empty is hidden. Pictures and the main headline come from Site identity; plans and trainers from their own pages.",
    "content.cta": "Free-trial button and closing band",
    "content.ctaLabel": "Button text (default: Start your free trial)",
    "content.ctaTitle": "Closing band title",
    "content.ctaText": "Closing band text",
    "content.stats": "Numbers people trust",
    "content.statsHint": "Up to 4 numbers, for example 1,200+ and members.",
    "content.statValue": "Number",
    "content.statLabel": "Label",
    "content.features": "Features",
    "content.icon": "Icon (emoji)",
    "content.title": "Title",
    "content.text": "Text",
    "content.testimonials": "Member reviews",
    "content.name": "Name",
    "content.role": "Description (optional)",
    "content.quote": "Review",
    "content.faq": "Questions",
    "content.question": "Question",
    "content.answer": "Answer",
    "content.apps": "Mobile app",
    "content.ios": "App Store link",
    "content.android": "Google Play link",
    "content.add": "Add",
    "content.saved": "Content saved",
    "gym.library": "Library",
    "gym.library.tags": "Tags",
    "gym.library.tagsHint": "Members filter the library by tags: workout style, equipment, focus and body area.",
    "gym.library.type.STYLE": "Style",
    "gym.library.type.EQUIPMENT": "Equipment",
    "gym.library.type.FOCUS": "Focus",
    "gym.library.type.BODY_AREA": "Body area",
    "gym.library.tagName": "Tag name",
    "gym.library.addTag": "Add tag",
    "gym.library.deleteTag": "Remove the tag {name} from all videos?",
    "gym.library.remove": "Remove",
    "gym.library.videos": "Videos",
    "gym.library.recipes": "Recipes",
    "gym.library.search": "Search by title",
    "gym.library.byTag": "Filter by tag",
    "gym.library.title": "Title",
    "gym.library.program": "Program",
    "gym.library.duration": "Duration",
    "gym.library.editTags": "Edit tags",
    "gym.library.tagsOf": "Tags: {title}",
    "gym.library.noTags": "Add tags above first.",
    "gym.library.saved": "Tags saved",
    "gym.library.emptyTitle": "The library is empty",
    "gym.library.emptyText": "Videos and recipes show up here after you upload them inside programs.",
    "gym.calendar": "Workout calendar",
    "gym.calendar.new": "New calendar",
    "gym.calendar.edit": "Edit calendar",
    "gym.calendar.name": "Calendar name",
    "gym.calendar.nameRequired": "Enter the calendar name",
    "gym.calendar.forPlan": "For members of plan",
    "gym.calendar.allMembers": "All members",
    "gym.calendar.enabled": "Visible to members",
    "gym.calendar.saved": "Calendar saved",
    "gym.calendar.deleteNote": "Deleting a calendar deletes all its days.",
    "gym.calendar.emptyTitle": "No calendar yet",
    "gym.calendar.emptyText": "Create a monthly calendar and put a workout on each day; members see today's workout.",
    "gym.calendar.addTo": "Add to {day}",
    "gym.calendar.add": "Add",
    "gym.calendar.remove": "Remove",
    "gym.calendar.kind.item": "Video / recipe",
    "gym.calendar.kind.program": "Program",
    "gym.calendar.kind.note": "Note / rest",
    "gym.calendar.item": "Video or recipe",
    "gym.calendar.program": "Program",
    "gym.calendar.pick": "Choose",
    "gym.calendar.noteTitle": "Title",
    "gym.calendar.restDay": "Rest day",
    "gym.calendar.note": "Note",
    "gym.calendar.pickSomething": "Choose something first",
    "gym.calendar.dragHint": "Drag an entry to another day to move it",
  },
};

export const gymMenu = [
  { key: "members", labelKey: "nav.members", icon: "pi pi-fw pi-users", url: "/members", module: "MEMBERSHIPS", order: 40 },
  { key: "plans", labelKey: "nav.plans", icon: "pi pi-fw pi-ticket", url: "/plans", module: "MEMBERSHIPS", order: 45 },
  { key: "trainers", labelKey: "nav.trainers", icon: "pi pi-fw pi-id-card", url: "/trainers", module: "INSTRUCTORS", order: 50 },
  { key: "content", labelKey: "nav.content", icon: "pi pi-fw pi-pencil", url: "/site-content", module: "MEMBERSHIPS", order: 55 },
  { key: "library", labelKey: "nav.library", icon: "pi pi-fw pi-video", url: "/library", module: "LIBRARY", order: 60 },
  { key: "calendar", labelKey: "nav.calendar", icon: "pi pi-fw pi-calendar", url: "/calendar", module: "CALENDAR", order: 65 },
];
